/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const GraphMutationResponse = zod.object({
  affectedContentUuids: zod.array(zod.uuid().describe('UUID v4 identifier')),
  created: zod.array(
    zod.object({
      clientId: zod.string(),
      uuid: zod.uuid().describe('UUID v4 identifier'),
    }),
  ),
  deletedContentUuids: zod.array(zod.uuid().describe('UUID v4 identifier')),
  deletedLineageUuids: zod.array(zod.uuid().describe('UUID v4 identifier')),
  deletionCount: zod.int(),
  ownership: zod.enum(['user_owned', 'agent_owned']),
  sourceMessageContentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
  versioned: zod.array(
    zod.object({
      newUuid: zod.uuid().describe('UUID v4 identifier'),
      oldUuid: zod.uuid().describe('UUID v4 identifier'),
    }),
  ),
  warnings: zod.array(zod.string()),
});

export type GraphMutationResponse = zod.input<typeof GraphMutationResponse>;
export type GraphMutationResponseOutput = zod.output<typeof GraphMutationResponse>;
